import { motion } from "framer-motion";
import { Shield, Zap, Lock, Briefcase, Radar, RefreshCcw, HeartHandshake, BadgeCheck } from "lucide-react";
import { VALUES } from "@/lib/content";
import { EASE } from "../site/motion";

const ICONS = [Shield, Zap, Lock, Briefcase, Radar, RefreshCcw, HeartHandshake, BadgeCheck];

export const Keycaps = () => (
  <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
    {VALUES.map((v, i) => {
      const Icon = ICONS[i];
      return (
        <motion.div
          key={v}
          data-testid={`value-${v.toLowerCase().replace(/\s/g, "-")}`}
          initial={{ opacity: 0, y: 30, rotateX: 25 }}
          whileInView={{ opacity: 1, y: 0, rotateX: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.8, ease: EASE, delay: i * 0.06 }}
          className="keycap group relative aspect-[1.05] cursor-default rounded-[18px] bg-cream p-5 text-skaris-navy"
        >
          <span className="absolute right-5 top-5 text-right font-display text-sm font-semibold md:text-base">{v}</span>
          <Icon className="absolute bottom-5 left-5 h-6 w-6 transition-transform duration-500 group-hover:rotate-12" strokeWidth={2} />
          <span className="absolute bottom-5 right-5 font-mono text-[10px] text-skaris-navy/60">0{i + 1}</span>
        </motion.div>
      );
    })}
  </div>
);
